// readCompanySlug.js — resolve the active company slug from the page DOM.
//
// Rails emits the slug as the `company-slug` attribute (NOT `data-company-slug`) on #react-root —
// react_app.js reads it the same way (`node.getAttribute("company-slug")`). The pre-fix VsNavLower
// read `[data-company-slug]`, which matched NOTHING, so slug=null → fetchChats short-circuited →
// the side-nav showed "Couldn't load chats. Retry." (DEFECT #2).
//
// Resolution order (first hit wins):
//   1. #react-root[company-slug]             — the canonical React mount (every agent page)
//   2. [company-slug]                        — any element carrying the slug
//   3. [data-company-slug]                   — belt-and-suspenders for non-React pages (nav emits it)
//
// `doc` is injectable so this is unit-testable with a tiny DOM stub (no jsdom, no JSX transform).
export function readCompanySlug(doc = (typeof document !== "undefined" ? document : null)) {
  try {
    if (!doc) return null
    const root = doc.getElementById && doc.getElementById("react-root")
    const fromRoot = root && root.getAttribute("company-slug")
    if (fromRoot) return fromRoot
    const any = doc.querySelector && doc.querySelector("[company-slug]")
    if (any) return any.getAttribute("company-slug")
    const nav = doc.querySelector && doc.querySelector("[data-company-slug]")
    return nav ? nav.getAttribute("data-company-slug") : null
  } catch (_e) {
    return null
  }
}
